// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form {
  border-radius: 5px;
  width: 80%;
  height: 100%;
  /* height: 600px; */
}

input:-webkit-autofill {
  background-color: #FAFFBD !important;
}

input{
  -webkit-text-size-adjust: none;
}

.form-body-contact {
  text-align: left;
  width: 41.6vw;
  margin-left: 5.3vw;
}

.form-body-contact > * {
  padding: 5px;
  display: flex;
}

.form__label {
  position: absolute;
  /* top: 10px; */
  font-family: "N27";
  font-style: italic;
  font-weight: 400;
  font-size: 1.4vh;
  /* line-height: 22px; */

  /* height: 100%; */
  margin-left: 30px;
}

.checkbox {
  transform: rotate(-45deg);
  min-height: 16px;
  min-width: 16px;
  height: 1.4vh;
  width: 1.4vh;
  margin: 1px;
}

.form__input {
  border: none;
  border-bottom: 0.5px solid black;
  width: 100%;
  height: 50px;
  background-color: transparent;
  font-family: "N27";
  font-style: italic;
  font-weight: 400;
  font-size: 20px;
  margin-right: 20px;
}

/* .form__inputinput:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active{ 
  -webkit-box-shadow: 0 0 0 30px transparent !important;
  transition: background-color 5000s ease-in-out 2s;
} */

input:-webkit-autofill, input:-webkit-autofill:focus input:-webkit-autofill, input:-webkit-autofill:hover {
  -webkit-text-fill-color: inherit;
  -webkit-box-shadow: 0 0 0 1000px #EDEDED inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

.form__input[data-autocompleted]{
  background-color: transparent !important;
}


.form__input::placeholder {
  color: #b6b7b2;
}

.form__input:focus {
  outline: none;
}

.form-btn {
  position: relative;
  width: 41.7vh;
  height: 11.5vh;

  font-family: "N27";
  /* font-style: italic; */
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  transform: skew(-20deg);
  background: #eff0eb;
  color: #151515;
  border: 0.5px solid #151515;
  cursor: pointer;
}

.form-btn:hover {
  background: #000000;
  color: #ffffff;
}

.form-footer {
  text-align: center;
}

.error {
  margin: 0;
  font-family: "N27";
  font-style: italic;
  font-weight: 400;
  font-size: 12px;
  color: transparent;
}

.error p{
  margin: 0;
}

.form-footer {
  position: absolute;
  width: 100%;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  top: 84vh;
}

.linecon {
  position: absolute;
  width: 84vw;
  height: 0px;
  left: 8vw;
  /* top: 60px; */
  border: 0.5px solid #151515;
}

.mob {
  display: none;
}

/* .checkbox input[type="checkbox"]:checked{
    border: 2px solid #fff!important;
    border-radius: 0.3em!important;
    background: #50565a!important;
    box-shadow: 2px 1px 0 #50565a!important;
  } */
/*///////////////////////////////////////////////////////////////*/
.newsletters {
  display: flex;
  align-content: center;
  align-items: center;
  padding: 0px;
  margin-top: 10px;
  margin-left: 5px;
}

input[type="checkbox"] {
  /* Add if not using autoprefixer */
  appearance: none;
  /* For iOS < 15 to remove gradient background */
  background-color: #EFF0EB(255, 255, 255);
  /* Not removed via appearance */
  margin: 0;
  font: inherit;
  color: rgb(0, 0, 0);
  width: 20px;
  height: 20px;
  border: 2px solid rgb(0, 0, 0);
  border-radius: 0.15em;
  transform: translateY(-0.075em);
  transform: rotate(-45deg);
  display: grid;
  place-content: center;
}

input[type="checkbox"]::before {
  content: "";
  width: 10px;
  height: 10px;
}

input[type="checkbox"]:checked::before {
  background-color: #282828;
  transform: scale(1);
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

  .mob {
    display: block;
    /* width: 100%; */
    /* display: flex; */
    /* font-size: 7.5px !important; */
  }

  .form {
    border-radius: 5px;
    width: 90vw;
    margin: 0;
    padding: 0;
  }

  .form-body-contact {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0;
  }

  .form__input {
    width: 90%;
    height: 30px;
    background-color: transparent;
    font-family: "N27";
    font-style: italic;
    font-weight: 400;
    font-size: 12px;
  }

  .form-btn {
    position: relative;
    width: 176px;
    height: 40px;
    font-size: 12px;
  }

  .form__label {
    position: relative;
    margin-left: 15px;
    /* left: 17px;
      font-size: 10px; */
  }

  .linecon {
  }

  .sr {
  }

  .sl {
  }

  .error {
    font-size: 10px;
  }

  .form-footer {
    top: unset;
    position: unset;
    margin-top: 25px;
    /* position: relative;
      top: 15vh;
      left: -4vh; */
  }

  .socials h2 {
    margin-top: 5px !important;
    font-size: 7.5px !important;
    margin-top: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Fom/components/ContactForm/ContactForm.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;;EAEvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;;;GAMG;;AAEH;EACE,gCAAgC;EAChC,8CAA8C;EAC9C,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA;EACE,wCAAwC;AAC1C;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;;EAEd,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;KAKK;AACL,kEAAkE;AAClE;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAElC,gBAAgB;EAChB,+CAA+C;EAC/C,wCAAwC;EACxC,+BAA+B;EAC/B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,qBAAqB;EACrB,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB;wBACoB;EACtB;;EAEA;EACA;;EAEA;EACA;;EAEA;EACA;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB;;mBAEe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,gBAAgB;EAClB;AACF","sourcesContent":[".form {\n  border-radius: 5px;\n  width: 80%;\n  height: 100%;\n  /* height: 600px; */\n}\n\ninput:-webkit-autofill {\n  background-color: #FAFFBD !important;\n}\n\ninput{\n  -webkit-text-size-adjust: none;\n}\n\n.form-body-contact {\n  text-align: left;\n  width: 41.6vw;\n  margin-left: 5.3vw;\n}\n\n.form-body-contact > * {\n  padding: 5px;\n  display: flex;\n}\n\n.form__label {\n  position: absolute;\n  /* top: 10px; */\n  font-family: \"N27\";\n  font-style: italic;\n  font-weight: 400;\n  font-size: 1.4vh;\n  /* line-height: 22px; */\n\n  /* height: 100%; */\n  margin-left: 30px;\n}\n\n.checkbox {\n  transform: rotate(-45deg);\n  min-height: 16px;\n  min-width: 16px;\n  height: 1.4vh;\n  width: 1.4vh;\n  margin: 1px;\n}\n\n.form__input {\n  border: none;\n  border-bottom: 0.5px solid black;\n  width: 100%;\n  height: 50px;\n  background-color: transparent;\n  font-family: \"N27\";\n  font-style: italic;\n  font-weight: 400;\n  font-size: 20px;\n  margin-right: 20px;\n}\n\n/* .form__inputinput:-webkit-autofill,\ninput:-webkit-autofill:hover, \ninput:-webkit-autofill:focus, \ninput:-webkit-autofill:active{ \n  -webkit-box-shadow: 0 0 0 30px transparent !important;\n  transition: background-color 5000s ease-in-out 2s;\n} */\n\ninput:-webkit-autofill, input:-webkit-autofill:focus input:-webkit-autofill, input:-webkit-autofill:hover {\n  -webkit-text-fill-color: inherit;\n  -webkit-box-shadow: 0 0 0 1000px #EDEDED inset;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n.form__input[data-autocompleted]{\n  background-color: transparent !important;\n}\n\n\n.form__input::placeholder {\n  color: #b6b7b2;\n}\n\n.form__input:focus {\n  outline: none;\n}\n\n.form-btn {\n  position: relative;\n  width: 41.7vh;\n  height: 11.5vh;\n\n  font-family: \"N27\";\n  /* font-style: italic; */\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 29px;\n  transform: skew(-20deg);\n  background: #eff0eb;\n  color: #151515;\n  border: 0.5px solid #151515;\n  cursor: pointer;\n}\n\n.form-btn:hover {\n  background: #000000;\n  color: #ffffff;\n}\n\n.form-footer {\n  text-align: center;\n}\n\n.error {\n  margin: 0;\n  font-family: \"N27\";\n  font-style: italic;\n  font-weight: 400;\n  font-size: 12px;\n  color: transparent;\n}\n\n.error p{\n  margin: 0;\n}\n\n.form-footer {\n  position: absolute;\n  width: 100%;\n  left: 0px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: auto;\n  top: 84vh;\n}\n\n.linecon {\n  position: absolute;\n  width: 84vw;\n  height: 0px;\n  left: 8vw;\n  /* top: 60px; */\n  border: 0.5px solid #151515;\n}\n\n.mob {\n  display: none;\n}\n\n/* .checkbox input[type=\"checkbox\"]:checked{\n    border: 2px solid #fff!important;\n    border-radius: 0.3em!important;\n    background: #50565a!important;\n    box-shadow: 2px 1px 0 #50565a!important;\n  } */\n/*///////////////////////////////////////////////////////////////*/\n.newsletters {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  padding: 0px;\n  margin-top: 10px;\n  margin-left: 5px;\n}\n\ninput[type=\"checkbox\"] {\n  /* Add if not using autoprefixer */\n  -webkit-appearance: none;\n  appearance: none;\n  /* For iOS < 15 to remove gradient background */\n  background-color: #EFF0EB(255, 255, 255);\n  /* Not removed via appearance */\n  margin: 0;\n  font: inherit;\n  color: rgb(0, 0, 0);\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgb(0, 0, 0);\n  border-radius: 0.15em;\n  transform: translateY(-0.075em);\n  transform: rotate(-45deg);\n  display: grid;\n  place-content: center;\n}\n\ninput[type=\"checkbox\"]::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n}\n\ninput[type=\"checkbox\"]:checked::before {\n  background-color: #282828;\n  transform: scale(1);\n}\n\n@media only screen and (max-width: 600px) {\n  .desktop {\n    display: none;\n  }\n\n  .mob {\n    display: block;\n    /* width: 100%; */\n    /* display: flex; */\n    /* font-size: 7.5px !important; */\n  }\n\n  .form {\n    border-radius: 5px;\n    width: 90vw;\n    margin: 0;\n    padding: 0;\n  }\n\n  .form-body-contact {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin: 0;\n  }\n\n  .form__input {\n    width: 90%;\n    height: 30px;\n    background-color: transparent;\n    font-family: \"N27\";\n    font-style: italic;\n    font-weight: 400;\n    font-size: 12px;\n  }\n\n  .form-btn {\n    position: relative;\n    width: 176px;\n    height: 40px;\n    font-size: 12px;\n  }\n\n  .form__label {\n    position: relative;\n    margin-left: 15px;\n    /* left: 17px;\n      font-size: 10px; */\n  }\n\n  .linecon {\n  }\n\n  .sr {\n  }\n\n  .sl {\n  }\n\n  .error {\n    font-size: 10px;\n  }\n\n  .form-footer {\n    top: unset;\n    position: unset;\n    margin-top: 25px;\n    /* position: relative;\n      top: 15vh;\n      left: -4vh; */\n  }\n\n  .socials h2 {\n    margin-top: 5px !important;\n    font-size: 7.5px !important;\n    margin-top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
